export default "__VITE_ASSET__BKTGxOB4__"